import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftRequestAutoconfirmFavoriteSelectedPayload {
  autoConfirm: 'on' | 'off';
  designDate: number;
}

/**
 * Fires when a user turns autoconfirm favorites ON/OFF on the shift request form
 * Event: dental_portal:shift_request:autoconfirm_favorite_selected
 */
export function fireShiftRequestAutoconfirmFavoriteSelected(
  payload: IShiftRequestAutoconfirmFavoriteSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:shift_request:autoconfirm_favorite_selected',
    {
      'auto-confirm': payload.autoConfirm,
      design_date: payload.designDate,
    },
  );
}
